import { listSideBar } from "@/functions/dinamisData";
import useHeader from "@/functions/useHeader";
import { ChevronLeftSvg, ChevronRightSvg } from "@/public/svg";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import React, { useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";

export default function Sidebar({ children }) {
  const { session } = useHeader();
  const pathname = usePathname();
  const [collapse, setCollapse] = useState(false);

  const isListSideBar = useMemo(() => {
    let datas = listSideBar()?.filter((val) =>
      (val?.href === "dompet-digital" ||
        val?.href === "jaringan-saya" ||
        (session?.user?.data?.mitra_level > 4 &&
          val?.href == "laporan-belanja")) &&
      session?.user?.data?.mitra_level > 2 // Selain Distributor
        ? null
        : val
    );
    return session?.user?.data?.mitra_level < 5
      ? datas
      : datas?.map((val) => {
          let ka = val;
          if (ka?.href == "list-order") {
            ka.label = "Transaksi Saya";
            ka.href = "daftar-transaksi";
          }
          if (ka?.href == "customer-saya") {
            ka.label = "Daftar Alamat";
            ka.href = "daftar-alamat";
            ka.anotherHref = [
              "daftar-alamat/tambah-alamat",
              "daftar-alamat/edit-alamat"
            ];
          }
          return ka;
        });
  }, [listSideBar, session?.user?.data?.mitra_level]);

  return (
    <React.Fragment>
      <aside
        className={twMerge(
          !collapse ? "w-full" : "w-auto",
          `bg-shadesGON-50 max-h-screen pb-8 px-2 max-w-[240px] relative overflow-hidden overflow-y-scroll pt-36`,
          "hidden md:flex md:flex-col"
        )}
      >
        <div
          onClick={() => setCollapse(!collapse)}
          className="absolute top-0 right-0 bg-primaryGON-400 p-2 rounded-bl-[8px] cursor-pointer pt-36 z-[2]"
        >
          <div className="text-shadesGON-50 w-4 h-4 rounded-bl-[8px] z-[1]">
            {collapse ? <ChevronRightSvg /> : <ChevronLeftSvg />}
          </div>
        </div>
        {isListSideBar?.map((item, index) => (
          <React.Fragment key={index}>
            <SidebarMenu
              icon={item?.icon}
              label={item?.label}
              colors={item?.colors}
              onClick={item?.onClick}
              disabled={
                session?.user?.data?.mitra_level > 2 &&
                (item?.href == "dompet-digital" || item?.href == "jaringan-saya" ||
                  (session?.user?.data?.mitra_level > 4 &&
                    item?.href == "laporan-belanja"))
              }
              href={`/member-area/${item?.href}`}
              active={
                item?.anotherHref?.find(
                  (val) => `/member-area/${val}` == pathname
                ) || pathname === `/member-area/${item?.href}`
              }
              collapse={collapse}
            />
            {item?.divider && <hr className="my-2" />}
          </React.Fragment>
        ))}
      </aside>
      <aside
        className={twMerge(
          ` w-full bg-shadesGON-50 px-2 overflow-hidden overflow-x-scroll sticky top-[7rem]`,
          "flex md:hidden z-50 justify-between"
        )}
      >
        {isListSideBar?.map((item, index) => (
          <React.Fragment key={index}>
            <SidebarMenu
              icon={item?.icon}
              label={item?.label}
              colors={item?.colors}
              onClick={item?.onClick}
              href={`/member-area/${item?.href}`}
              active={
                item?.anotherHref?.find(
                  (val) => `/member-area/${val}` == pathname
                ) || pathname === `/member-area/${item?.href}`
              }
              collapse={true}
            />
            {item?.divider && <hr className="my-2" />}
          </React.Fragment>
        ))}
      </aside>
    </React.Fragment>
  );
}

function SidebarMenu({
  disabled = false,
  collapse = false,
  active = false,
  label,
  icon,
  alert = false,
  href,
  onClick,
  colors = "greyscale"
}) {
  const router = useRouter();
  return onClick ? (
    <div
      onClick={() => {
        !disabled && onClick();
      }}
      className={twMerge(
        "group",
        active ? "text-primaryGON-400" : `text-${colors}GON-500`,
        "md:relative flex gap-2 items-center py-5 px-8 cursor-pointer",
        disabled && "text-greyscaleGON-100 cursor-not-allowed"
      )}
    >
      <div>
        {icon({
          className: twMerge(
            active ? "text-primaryGON-400" : `text-${colors}GON-500`,
            disabled && "text-greyscaleGON-100",
            "w-5 h-5 "
            // collapse && "w-7 h-7"
          )
        })}
      </div>
      <p
        className={twMerge(
          active ? "text-primaryGON-400" : `text-${colors}GON-500`,
          collapse && "hidden"
        )}
      >
        {label}
      </p>
      {alert && (
        <div className="absolute right-2 w-2 h-2 rounded-full bg-primaryGON-400" />
      )}
      {collapse && (
        <div
          className="absolute md:left-full w-max 
        px-2 py-1 ml-5 md:ml-6 
        bg-primaryGON-100 text-primaryGON-400 
        rounded-t-lg rounded-br-lg 
        p2-medium
        invisible opacity-20 -translate-y-3 transition-all
        group-hover:visible group-hover:opacity-100 group-hover:translate-x-0
        z-50
        "
        >
          {label}
        </div>
      )}
    </div>
  ) : (
    <Link
      aria-label={disabled ? "/" : href}
      as={disabled ? "/" : href}
      shallow
      href={disabled ? "/" : href}
      className={twMerge(
        "group",
        active ? "text-primaryGON-400" : `text-${colors}GON-700`,
        "md:relative flex gap-2 items-center py-5 px-8 cursor-pointer",
        disabled && "text-greyscaleGON-100 cursor-not-allowed"
      )}
    >
      <div>
        {icon({
          className: twMerge(
            "group-hover:text-primaryGON-400",
            active ? "text-primaryGON-400" : `text-${colors}GON-500`,
            disabled && "text-greyscaleGON-100",
            "w-5 h-5 "
            // collapse && "w-7 h-7"
          )
        })}
      </div>
      <p
        className={twMerge(
          "p2-medium group-hover:text-primaryGON-400",
          active ? "text-primaryGON-400" : `text-${colors}GON-500`,
          collapse && "hidden"
        )}
      >
        {label}
      </p>
      {alert && (
        <div className="absolute right-2 w-2 h-2 rounded-full bg-primaryGON-400" />
      )}
      {collapse && (
        <div
          className="absolute md:left-full w-max 
        px-2 py-1 ml-5 md:ml-6 
        bg-primaryGON-100 text-primaryGON-400 
        rounded-t-lg rounded-br-lg 
        p2-medium
        invisible opacity-20 -translate-y-3 transition-all
        group-hover:visible group-hover:opacity-100 group-hover:translate-x-0
        z-50
        "
        >
          {label}
        </div>
      )}
    </Link>
  );
}
